import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/inbox')({
  beforeLoad: async ({ search }) => {
    search.inbox = true
    throw redirect({
      to: '/',
      search,
    })
  },
})
